/* ct-closeout-floor.js — client-side facets + sort for the closeout floor
   (sections/ct-closeout-floor.liquid). Cards are server-rendered from the
   real collection with data-price (cents) / data-save (cents) / data-type /
   data-size ("43|65") / data-title; nothing here fetches anything.
   Semantics mirror ct-collection.js: OR within a facet group, AND across
   groups. Price is three fixed bands matched from data-price. Counts are
   live: each facet's count is recomputed against the OTHER groups' active
   selections on every change. Sort is stable (index tie-break) and
   defaults to biggest savings. Idempotent; every querySelector guarded. */
(function () {
  'use strict';

  function slice(list) { return Array.prototype.slice.call(list); }

  function intAttr(el, attr) {
    var n = parseInt(el.getAttribute(attr), 10);
    return isNaN(n) ? 0 : n;
  }

  /* Fixed price bands (cents) — mirror the sidebar labels. */
  function inBand(cents, band) {
    switch (band) {
      case 'under-1000': return cents < 100000;
      case '1000-3000': return cents >= 100000 && cents <= 300000;
      case '3000-plus': return cents > 300000;
      default: return false;
    }
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-ct-floor-init') === '1') return;
    root.setAttribute('data-ct-floor-init', '1');

    var cardsWrap = root.querySelector('[data-ct-cards]');
    if (!cardsWrap) return;

    var cards = slice(cardsWrap.querySelectorAll('[data-ct-card]'));
    var inputs = slice(root.querySelectorAll('input[data-facet]'));
    var shownEl = root.querySelector('[data-ct-shown]');
    var shownWordEl = root.querySelector('[data-ct-shown-word]');
    var emptyEl = root.querySelector('[data-ct-empty]');
    var clearBtns = slice(root.querySelectorAll('[data-ct-clear]'));
    var sortEls = slice(root.querySelectorAll('[data-ct-sort]'));
    var filterToggle = root.querySelector('[data-ct-filter-toggle]');
    var facetPanel = root.querySelector('[data-ct-facet-panel]');
    var filterCount = root.querySelector('[data-ct-filter-count]');

    /* ---------- filtering: OR within a group, AND across ---------- */

    function activeGroups() {
      var groups = {};
      inputs.forEach(function (input) {
        if (!input.checked) return;
        var g = input.getAttribute('data-facet');
        if (!g) return;
        (groups[g] = groups[g] || []).push(input.value);
      });
      return groups;
    }

    function cardMatches(card, groups) {
      for (var g in groups) {
        if (!Object.prototype.hasOwnProperty.call(groups, g)) continue;
        var values = groups[g];
        var ok = false;
        if (g === 'type') {
          ok = values.indexOf(card.getAttribute('data-type') || '') !== -1;
        } else if (g === 'size') {
          var raw = card.getAttribute('data-size') || '';
          var list = raw ? raw.split('|') : [];
          ok = values.some(function (v) { return list.indexOf(v) !== -1; });
        } else if (g === 'price') {
          var cents = intAttr(card, 'data-price');
          ok = values.some(function (v) { return inBand(cents, v); });
        }
        if (!ok) return false;
      }
      return true;
    }

    function applyFilters() {
      var groups = activeGroups();
      var active = 0;
      for (var g in groups) {
        if (Object.prototype.hasOwnProperty.call(groups, g)) active += groups[g].length;
      }

      var shown = 0;
      cards.forEach(function (card) {
        var match = cardMatches(card, groups);
        card.classList.toggle('is-hidden', !match);
        if (match) shown++;
      });

      if (shownEl) shownEl.textContent = String(shown);
      if (shownWordEl) shownWordEl.textContent = shown === 1 ? 'unit' : 'units';
      if (emptyEl) emptyEl.hidden = shown !== 0;
      cardsWrap.hidden = shown === 0 && cards.length > 0;
      clearBtns.forEach(function (btn) { btn.hidden = active === 0; });
      if (filterCount) {
        filterCount.textContent = String(active);
        filterCount.hidden = active === 0;
      }

      inputs.forEach(function (input) {
        var label = input.closest('label');
        if (label) label.classList.toggle('is-on', input.checked);
      });

      updateCounts(groups);
    }

    /* ---------- live counts ----------
       Count for a value = cards matching every OTHER group's active
       selections plus this value alone (standard facet arithmetic). */
    function updateCounts(groups) {
      inputs.forEach(function (input) {
        var g = input.getAttribute('data-facet');
        if (!g) return;
        var probe = {};
        for (var k in groups) {
          if (Object.prototype.hasOwnProperty.call(groups, k) && k !== g) probe[k] = groups[k];
        }
        probe[g] = [input.value];
        var n = 0;
        cards.forEach(function (card) { if (cardMatches(card, probe)) n++; });
        var countEl = input.closest('label') ? input.closest('label').querySelector('[data-ct-facet-count]') : null;
        if (countEl) countEl.textContent = '(' + n + ')';
        var label = input.closest('label');
        if (label) label.classList.toggle('is-zero', n === 0 && !input.checked);
      });
    }

    /* ---------- sort: stable (index tie-break), instant reorder ---------- */

    function compare(a, b, mode) {
      switch (mode) {
        case 'price-asc':
          return intAttr(a, 'data-price') - intAttr(b, 'data-price');
        case 'price-desc':
          return intAttr(b, 'data-price') - intAttr(a, 'data-price');
        case 'title':
          return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '');
        default: /* 'save' — biggest savings first */
          return intAttr(b, 'data-save') - intAttr(a, 'data-save');
      }
    }

    function applySort(mode) {
      var decorated = cards.map(function (card, i) { return { card: card, i: i }; });
      decorated.sort(function (a, b) {
        var d = compare(a.card, b.card, mode);
        return d !== 0 ? d : a.i - b.i;
      });
      cards = decorated.map(function (d) { return d.card; });
      cards.forEach(function (card) { cardsWrap.appendChild(card); });
    }

    /* ---------- wiring ---------- */

    inputs.forEach(function (input) {
      input.addEventListener('change', applyFilters);
    });

    clearBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        inputs.forEach(function (input) { input.checked = false; });
        applyFilters();
      });
    });

    sortEls.forEach(function (el) {
      el.addEventListener('change', function () {
        sortEls.forEach(function (other) { if (other !== el) other.value = el.value; });
        applySort(el.value);
      });
    });

    if (filterToggle && facetPanel) {
      filterToggle.addEventListener('click', function () {
        var open = facetPanel.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Default sort is biggest savings — the admin's manual collection
       order is not load-bearing here. */
    applySort('save');
    applyFilters();
  }

  function init() {
    document.querySelectorAll('[data-ct-closeout-floor]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
